import React, { useEffect, useState } from 'react';
import { PrimaryButton } from './PrimaryButton';
import { CHECKOUT_URL } from '../../utils/checkout';
import { trackMetaPixelEvent } from '../../utils/metaPixel';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > 640);
        ticking = false;
      });
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-brown/20 bg-bg-secondary/95 backdrop-blur-sm transition-transform duration-300 lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} aria-hidden={!visible} data-id="element-272" data-mp="2ixvlahj6pmaw">
      <div className="flex items-center justify-between gap-3 px-4 py-3" data-id="element-273" data-mp="2swt5j89kuto3">
        <div data-id="element-274" data-mp="o134xypcjmzp">
          <p className="font-heading text-sm font-bold text-ink" data-id="element-275" data-mp="o1cy1v5oua9m">19€</p>
          <p className="text-[11px] text-muted" data-id="element-276" data-mp="s1wsgqyvmzs2">Acceso inmediato</p>
        </div>
        <PrimaryButton size="md" showArrow={false} href={CHECKOUT_URL} onClick={() => trackMetaPixelEvent('InitiateCheckout', {
        value: 19,
        currency: 'EUR'
      })} data-id="element-277" data-mp="s3zru1lx659g">
          Quiero el Kit
        </PrimaryButton>
      </div>
    </div>;
}